import React from 'react';
import { hideModal, showQuestionModal } from './modals/QuestionModal';
import { translate } from '../core/i18n';
import { useEffect, useState } from 'react';
import { store } from '../core/state';
import { EDITOR_VIEW_NAME } from '../core/constants';
import { executeCodeRequested } from '../features/executecode';
import { getStartCode } from '../features/coderunner';
import { saveUserData } from '../core/code/saver';
import ModernHeaderButton from './buttons/base/ModernHeaderButton';
import { refreshPage } from '../features/utils';
import { resetCurrentProjectData } from '../core/project/projectdata';

export const CodeControlsMenu = (props: { runCode?: () => void, cfg?: any, fullscreenButton?: React.ReactNode }) => {
  const [editorState, setEditorState] = store.useState(EDITOR_VIEW_NAME);
  const [waitBlock, setWaitBlock] = useState(false);
  const keyPressed = (event: any): void => {
    if (event.ctrlKey && event.key === "s") {
      event.preventDefault();
      startRequested();
    }
  }

  useEffect(() => {
    document.addEventListener("keydown", keyPressed, false);

    return () => {
      document.removeEventListener("keydown", keyPressed, false);
    };
  });

  const startRequested = (): void => {
    if (waitBlock) return;
    setWaitBlockTime();
    executeCodeRequested();
    if (props?.runCode !== undefined) {
      props?.runCode();
    }
  }

  const resetRequested = (): void => {
    if (waitBlock) return;
    setWaitBlockTime();
    showQuestionModal(
      translate("editor-reset-code-modal-title"),
      translate("editor-reset-code-modal-message"),
      resetUserCodeRequested,
      cancelResetCode
    );
  }

  const resetUserCodeRequested = async (): Promise<void> => {
    if (waitBlock) return;
    setWaitBlockTime();
    await resetCurrentProjectData();
    //props.resetCode();
    hideModal();
    refreshPage();
  }

  const cancelResetCode = (): void => {
    hideModal();
    setWaitBlock(false);
  }

  const setWaitBlockTime = (): void => {
    setWaitBlock(true);
    setTimeout(() => {
      setWaitBlock(false);
    }, 1000);
  }

  let resetButton = true;
  if (props.cfg && props.cfg.resetButtonEnabled !== undefined) {
    resetButton = props.cfg.resetButtonEnabled;
  }
  return (
    <div className="form-inline" onKeyPress={keyPressed}>
      <ModernHeaderButton icon="play" onClick={startRequested} title={translate('view-editor-play-button')} text={'Starten'} variant={'primary'} />
      {props.fullscreenButton}
      {resetButton && <ModernHeaderButton icon="rotate-right" onClick={resetRequested} title={translate('view-editor-reset-button')} text={'Reset'} variant={'secondary'} />}
    </div>
  );
}
